import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';


export const itemsService = {
    getItemsMasterData,
    getItemsList,
    getItemTableHeader,
    updateItemTableHeader,
    setItemActive,
    setIteminActive,
    saveNewItem,
    deleteItems,
    GetItemDetails,
    updateItem,
    submitItemImage,
    submitItemGroupImage,
    getItemBundleHistory,
    getItemTransaction,
    getItemHistory,
    getItemRateHistory,
    getItemImages,
    getItemStockInformation,
    getItemSalesOrderSummary,
    submitRateHistory,
    getAssociateItems

};




async function  submitRateHistory(body) {
   return apiClient.post(`/submit-rate-history`,body,  authHeader())
}



function getAssociateItems(item_id){
  return apiClient.get(`/get-associate-items/${item_id}`, authHeader())
}


async function  getItemsMasterData() {
   return apiClient.get(`/get-item-master-data`,  authHeader())
}

async function  getItemStockInformation(id) {
   return apiClient.get(`/item-stock-information/${id}`,  authHeader())
}


async function  getItemSalesOrderSummary(id) {
   return apiClient.get(`/item-sales-summary/${id}`,  authHeader())
}


async function  getItemsList() {
   return apiClient.get(`/get-item-list`,  authHeader())
}


async function  getItemTableHeader() {
   return apiClient.get(`/get-table-header`,  authHeader())
}

function updateItemTableHeader(xmlString){
   var body = {xml_string : xmlString}
   return apiClient.put('/update-item-table-header', body, authHeader())
        
 }

function setItemActive(xmlString){
   var body = {xml_string : xmlString}
  return apiClient.put('/set-item-active', body, authHeader())    
 }

function setIteminActive(xmlString){
   var body = {xml_string : xmlString}
  return apiClient.put('/set-item-inactive', body, authHeader())
       
 }


function deleteItems(xmlString){
   var body = {xml_string : xmlString}
  return apiClient.put('/delete-items', body, authHeader())
       
 }


function  saveNewItem(body){
  return apiClient.post('/save-new-item', body, authHeader())
       
 }


function  updateItem(body){
  return apiClient.put('/update-item', body, authHeader());
       
 }

function  GetItemDetails(item_id){
  return apiClient.get(`/get-item-details/${item_id}`, authHeader())
       
 }

 function submitItemImage(body){
   return apiClient.post(`/submit-item-image`, body, authHeader())
 }


 function submitItemGroupImage(body){
   return apiClient.post(`/submit-item-group-image`, body, authHeader())
 }




 function getItemBundleHistory(item_id){
   return apiClient.get(`/get-item-bundle-history/${item_id}`, authHeader())
 }


 function getItemTransaction(item_id){
   return apiClient.get(`/get-item-transactions/${item_id}`, authHeader())
 }



 function getItemHistory(item_id){
   return apiClient.get(`/get-item-history/${item_id}`, authHeader())
 }



 function getItemRateHistory(item_id){
   return apiClient.get(`/get-item-rate-history/${item_id}`, authHeader())
 }


 function getItemImages(item_id){
   return apiClient.get(`/get-item-images/${item_id}`, authHeader())
 }







